import React, { useMemo } from 'react'
import {
    createManageRoleStore,
    ManageRoleStoreContext,
} from './manageRoleStore'

export const ManageRoleProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    // Create a new store instance when this provider mounts
    const store = useMemo(() => createManageRoleStore(), [])
    return (
        <ManageRoleStoreContext.Provider value={store}>
            {children}
        </ManageRoleStoreContext.Provider>
    )
}
